/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, postDownload,tokenPost} from "./ajax";

const distributionCenter = {
  /**
   *  AJAX-搜索配送中心（分页）
   *  @param keys
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listDistributionCenter(keys,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_DISTRIBUTION_CENTER,
      {
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-删除配送中心
   * @param id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  delete(id, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_DISTRIBUTION_CENTER,
      {
        id: id,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-启用/停用配送中心
   * @param id
   * @param flag
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  stop(id, flag, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.STOP_DISTRIBUTION_CENTER,
      {
        id: id,
        flag: flag,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-添加配送中心
   *  @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  add(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_DISTRIBUTION_CENTER,
      {
        dcName : info.name,
        dcNum : info.num,
        contactName : info.contactName,
        mobileNo : info.mobileNo,
        dcAddress : info.address
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-修改配送中心
   *  @param info
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modify(info, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_DISTRIBUTION_CENTER,
      {
        dcName : info.name,
        dcNum : info.num,
        contactName : info.contactName,
        mobileNo : info.mobileNo,
        dcAddress : info.address,
        isStop: info.isStop
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取配送中心详情
   * @param id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquire(id, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_DISTRIBUTION_CENTER,
      {
        id: id,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-分页获取门店列表
   *  @param id
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listShop(id,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_SHOP_DISTRIBUTION_CENTER,
      {
        id: id,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取供应商列表
   *  @param id
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listSupplier(id,page, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_SUPPLIER,
      {
        id: id,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取中央厨房
   *  @param id
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquireKitchen(id,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_KITCHEN,
      {
        id: id,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-添加门店
   *  @param dcId
   *  @param shopId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addShop(dcId,shopId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_SHOP_DISTRIBUTION_CENTER,
      {
        dcId: dcId,
        shopId: shopId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除门店
   *  @param dcId
   *  @param shopId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  deleteShop(dcId,shopId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_SHOP,
      {
        dcId: dcId,
        shopId: shopId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-添加供应商
   *  @param dcId
   *  @param supplierId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addSupplier(dcId,supplierId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_SUPPLIER,
      {
        dcId: dcId,
        supplierId: supplierId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除供应商
   *  @param dcId
   *  @param supplierId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  deleteSupplier(dcId,supplierId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_SUPPLIER,
      {
        dcId: dcId,
        supplierId: supplierId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-修改中央厨房
   *  @param dcId
   *  @param kitchenId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modifyKitchen(dcId,kitchenId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_KITCHEN,
      {
        dcId: dcId,
        kitchenId: kitchenId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-添加采购货品
   *  @param dcId
   *  @param supplierId
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addPurchaseMaterial(dcId,materialId,supplierId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_PURCHASE_MATERIAL,
      {
        dcId: dcId,
        supplierId: supplierId,
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-修改采购货品
   *  @param dcId
   *  @param supplierId
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modifyPurchaseMaterial(dcId,materialId,supplierId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_PURCHASE_MATERIAL,
      {
        dcId: dcId,
        supplierId: supplierId,
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除货品（采购、产成品）
   *  @param dcId
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  deleteMaterial(dcId,materialId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_MATERIAL,
      {
        dcId: dcId,
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },

  /**
   *  AJAX-添加产成品
   *  @param dcId
   *  @param unitPrice
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addProduceMaterial(dcId,materialId,unitPrice,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_PRODUCE_MATERIAL,
      {
        dcId: dcId,
        unitPrice: unitPrice,
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-查询配送中心的货品（要货 && 调拨 添加货品 搜索接口）
   *  @param dcId
   *  @param keys
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  searchMaterial(dcId,keys,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.SEARCH_MATERIAL_DISTRIBUTION,
      {
        dcId: dcId,
        keys: keys,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加要货货品
   *  @param dcId
   *  @param unitPrice
   *  @param materialId
   *  @param shopId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addRequireMaterial(dcId,materialId,shopId,unitPrice,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_REQUIRE_MATERIAL,
      {
        dcId: dcId,
        unitPrice: unitPrice,
        materialId: materialId,
        shopIds: shopId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加调拨货品
   *  @param dcId
   *  @param unitPrice
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  addAllotMaterial(dcId,materialId,unitPrice,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_ALLOT_MATERIAL,
      {
        dcId: dcId,
        unitPrice: unitPrice,
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除调拨货品
   *  @param dcId
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  deleteAllotMaterial(dcId,materialId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_ALLOT_MATERIAL,
      {
        dcId: dcId,
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-删除要货货品
   *  @param shopId
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  deleteRequireMaterial(shopId,materialId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.DELETE_REQUIRE_MATERIAL,
      {
        shopId: shopId,
        materialId: materialId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取采购货品列表
   *  @param dcId
   *  @param supplierId
   *  @param keys
   *  @param page
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listPurchaseMaterial(dcId,supplierId,keys,page,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_PURCHASE_MATERIAL,
      {
        dcId: dcId,
        supplierId: supplierId,
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取生产货品列表
   *  @param dcId
   *  @param page
   *  @param keys
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listProduceMaterial(dcId,keys,page,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_PRODUCE_MATERIAL_DISTRIBUTION,
      {
        dcId: dcId,
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取调拨货品列表
   *  @param dcId
   *  @param page
   *  @param keys
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listAllotMaterial(dcId,keys,page,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_ALLOT_MATERIAL,
      {
        dcId: dcId,
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-分页获取要货货品列表
   *  @param dcId
   *  @param shopId
   *  @param page
   *  @param keys
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listRequireMaterial(dcId,shopId,keys,page,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_REQUIRE_MATERIAL,
      {
        dcId: dcId,
        shopId: shopId,
        keys: keys,
        pageIndex: page.pagination,
        pageSize: page.size,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取配送单价
   *  @param dcId
   *  @param materialId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  acquireDefaultPrice(dcId,materialId,shopId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ACQUIRE_DEFAULT_PRICE,
      {
        dcId: dcId,
        materialId: materialId,
        shopId: shopId
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-导出产成品
   * @param dcId
   * @param success
   * @param isLoadingExplicit
   * @param errorHandler
   */
  exportProduceMaterial(dcId,keys, success, isLoadingExplicit, errorHandler){
    postDownload.bind(this)(
      url.EXPORT_PRODUCE_MATERIAL,
      {
        dcId: dcId,
        keys: keys,
      },
      success,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-导出采购货品
   * @param dcId
   * @param success
   * @param isLoadingExplicit
   * @param errorHandler
   */
  exportPurchaseMaterial(dcId, supplierId, keys, success, isLoadingExplicit, errorHandler){
    postDownload.bind(this)(
      url.EXPORT_PURCHASE_MATERIAL,
      {
        dcId: dcId,
        supplierId: supplierId,
        keys: keys,
      },
      success,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default distributionCenter;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-distribution-center.js